<template>
  <div
    v-if="isShow"
    id="wait-guide-container"
    :class="['wait-guide-mask', pptModeIsShow ? 'wait-guide-mask-ppt':'']"
  >
    <!--幻灯片模式中的loading-->
    <div
      v-if="pptModeIsShow"
      class="preview-ppt-loading"
    >
      <div class="loading-proccess">
        <div
          class="proccessing"
          :style="{width: `${loadStatus}%`}"
        />
      </div>
      <div class="loading-word">
        {{ $t('正在切换预览模式，请稍候...') }}
      </div>
      <div
        v-if="!isDelivery && canLocalEdit"
        class="loading-button"
        @click="webLocalEdit"
      >
        {{ $t('本地打开') }}
      </div>
    </div>
    <!--pdf预览中的loading-->
    <div v-else>
      <!-- 进度条 或 转圈loading 部分 -->
      <div
        v-show="isShowLoad"
        class="wait-guide-loading"
      >
        <span
          v-if="loadIcon"
          class="loadingIcon"
        />
        <span
          v-else
          class="loadingBar"
        >
          <span
            class="innerBar"
            :style="{width: `${loadStatus}%`}"
          />
          <span class="innerBarTip">{{ `${loadStatus}%` }}</span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import {
  isClient, canEditNative, canLocalEdit,
} from 'js/util/util'

export default {
  props: {
    configLoad: {
      type: Object,
      default() {
        return {
          appearAfter: 5000, // 轮播语晚多少秒再出现
          carouselInterval: 4000, // 轮播切换间隔
        }
      },
    },
  },
  data() {
    return {
      loadStatus: 1, // 进度条的进度
      isShowLoad: false, // 是否显示转圈和进度条
      isShowGuidence: false, // 是否显示轮播语
      isSlow: false, // 是否进度条已经慢下来
      isShow: false, // 是否展示loading
      loadIcon: true, // true是转圈，false是进度条
      pptModeIsShow: false, // ppt模式的loading
      isDelivery: false, // 是不是外链中的loading。此页面用于网盘内预览和外链页预览都
      intervalTimer: null,
      timer: null,
      timeout: null,
    }
  },
  computed: {
    /**
         * 当前选中文件的信息
         */
    fileData() {
      return this.$store.state.curFileInfo
    },
    /**
         * 网盘内的预览，判断是否有 本地编辑权限
         */
    canLocalEdit() {
      if (this.isDelivery || JSON.stringify(this.fileData) == '{}') return
      if (!isClient()) {
        if (canEditNative(this.fileData.access_mode)) {
          return true
        }
        return false
      }
      if (canLocalEdit(this.fileData)) {
        return true
      }
      return false
    },
  },
  methods: {
    /**
         * 本地打开
         */
    webLocalEdit() {
      this.$emit('loadingAction', 'webLocalEdit')
    },
    /**
         * ppt 模式的渲染
         */
    pptRender() {
      this.initData()
      this.pptModeIsShow = this.$store.state.isSideMode
      if (this.$route && this.$route.name == 'link') {
        this.isDelivery = true
      }
      this.loadStatus = 1
      this.startProcess()
    },
    /**
         * 开始渲染loading
         */
    render(isIcon = true) {
      const vm = this
      vm.loadIcon = isIcon
      vm.initData()
      if (!vm.loadIcon) {
        vm.isShowLoad = true
        vm.startProcess()
        return
      }
      if (vm.timeout == null) {
        vm.timeout = setTimeout(() => {
          vm.isShowLoad = true
          if (this.carouselShow == null) {
            this.carouselShow = setTimeout(() => {
            }, vm.configLoad.appearAfter)
          }
        }, 1000)
      }
    },
    /**
         * 初始化该组件的data
         * 在切换文件时，需要重置这些参数
         */
    initData() {
      this.loadStatus = 1
      this.isShow = true
      this.isShowLoad = false
      this.isShowGuidence = false
      this.isSlow = false
      this.pptModeIsShow = false
      this.isDelivery = false
      this.clearAll()
    },
    /**
         * clear timeout and timeinterval
         */
    clearAll() {
      clearInterval(this.intervalTimer) // clear 轮播语
      clearInterval(this.timer) // clear 进度条
      clearTimeout(this.timeout) // clear 1s后进行转圈显示
      clearTimeout(this.carouselShow) // clear 5s后进行轮播语显示
      this.intervalTimer = null
      this.timer = null
      this.timeout = null
      this.carouselShow = null
    },
    /**
         * 出现进度条
         */
    startProcess() {
      const vm = this
      if (vm.timer == null) {
        vm.timer = setInterval(vm.makeProgress, 100)
      }
    },
    /**
         * 跟新进度条
         */
    makeProgress() {
      const vm = this
      if (vm.loadStatus === 99) {
        clearInterval(vm.timer)
        vm.timer = null
      } else if (vm.loadStatus >= 80) {
        vm.loadStatus++
        if (!vm.isSlow) {
          clearInterval(vm.timer)
          vm.timer = setInterval(vm.makeProgress, 600)
          vm.isSlow = true
        }
      } else {
        vm.loadStatus++
      }
    },
    /**
         * 关闭loading
         */
    close() {
      const vm = this
      vm.loadStatus = 99
      vm.clearAll()
      vm.isShow = false
    },
  },
}
</script>
<style lang="less">
.wait-guide-mask{
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  position: relative;
}
.wait-guide-mask-ppt {
  height: 100%;
  position: absolute;
  z-index: 1;
}
// --ppt mode start--
.preview-ppt-loading{
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.40);
  .loading-proccess{
    width: 313px;
    height: 8px;
    border-radius: 4px;
    margin: 0 auto;
    background: #6B6B6B;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    .proccessing{
      height: 8px;
      border-radius: 4px;
      position: absolute;
      background: #fff;
    }
  }
  .loading-word{
    width: 260px;
    margin: auto;
    color: #fff;
    font-size: 14px;
    text-align: center;
    top: 55%;
    transform: translateY(-50%);
    position: relative;
  }
  .loading-button{
    width: 88px;
    height: 32px;
    margin: 0 auto;
    color: #fff;
    font-size: 14px;
    text-align: center;
    border: 1px solid #C6CDD7;
    border-radius: 2px;
    line-height: 32px;
    top: 58%;
    transform: translateY(-50%);
    position: relative;
    cursor: pointer;
  }
}
// --ppt mode end--
.wait-guide-loading{
  overflow: hidden;
  // 转圈
  .loadingIcon{
    width: 93px;
    height: 93px;
    display: block;
    background: url(./images/loading.gif) center center no-repeat;
    background-size: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -46.5px;
    margin-left: -46.5px;
  }
  //进度条
  .loadingBar{
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -156.5px;
    width: 313px;
    height: 6px;
    display: block;
    background: #E8EBEF;
    border-radius: 4px;
    .innerBar{
      height: 100%;
      width: 100px;
      display: inline-block;
      position: absolute;
      background-color: #0A64FA;
      border-radius: 4px;
    }
    .innerBarTip{
      display: block;
      text-align: center;
      padding: 16px 0 20px;
      font-size: 14px;
      color: #637282;
      text-align: center;
      line-height: 24px;
    }
  }
}
.wait-guidance{
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -300px;
  margin-top: 80px;
  font-size: 14px;
  color: #637282;
  text-align: center;
  min-width: 600px;
  cursor: default;
  display: block;
}
.item-icon{
  width: 24px;
  height: 24px;
  vertical-align: middle;
}
.wait-guidance-part{
  display: inline-block;
  vertical-align: top;
  .wait-guidance-content{
    max-width: 460px;
    padding: 0px 24px 24px 24px;
    line-height: 24px;
    display: inline-block;
    text-align: left;
  }
  .wait-guidance-author{
    line-height: 24px;
    display: block;
    text-align: right;
    padding: 0px 24px 0px 0px;
    box-sizing: border-box;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.showUp {
  animation: reveal 1s ease-in-out;
}
@keyframes reveal {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.moveOut {
  animation: disapear 0.38s ease-in-out;
}
@keyframes disapear {
  from {
    padding-top: 0;
    opacity: 1;
  }
  to {
    padding-top: 20px;
    opacity: 0;
  }
}
</style>
